import { stringifyUrl } from "query-string";
import { IApiResourceResponse } from "../../@typings/client";
import { UsersLoader } from "./UsersLoader";
import { DeleteProfile, RestoreProfile, UpdateProfileRelations, CreateProfile } from "../typings/Profiles";
import { Nullable } from "../../@typings/typings";

export interface ProfilesQuery extends Record<string, Nullable<string | string[]>> {
  include?: ProfilesIncludes[];
  with_trashed?: "0" | "1";
}

export type ProfilesIncludes =
  | "admin"
  | "student"
  | "supervisor"
  | "tutor"
  | "parent"
  | "assistant"
  | "contenter"
  | "user"
  | "user.permissions"
  | "related_as_primary"
  | "related_as_secondary"
  | "related_as_primary.user"
  | "related_as_secondary.user";

export class ProfilesApi {
  public static createProfile(id: string, data: IApiResourceResponse<CreateProfile>, query: ProfilesQuery = {}) {
    const url = stringifyUrl({ url: "/users_profiles", query }, { arrayFormat: "comma" });
    return UsersLoader.post({ url, data });
  }

  public static deleteProfile(id: string, data: IApiResourceResponse<DeleteProfile>, query: ProfilesQuery = {}) {
    const url = stringifyUrl({ url: `/users_profiles/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }

  public static restoreProfile(id: string, data: IApiResourceResponse<RestoreProfile>, query: ProfilesQuery = {}) {
    const url = stringifyUrl({ url: `/users_profiles/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }

  public static updateProfileRelations(
    id: string,
    data: IApiResourceResponse<UpdateProfileRelations>,
    query: ProfilesQuery = {}
  ) {
    const url = stringifyUrl({ url: `/users_profiles/${id}`, query }, { arrayFormat: "comma" });
    return UsersLoader.patch({ url, data });
  }
}
